<template>
  <v-container fill-height align-center>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card id="content_card">
          <v-card-title>
            <h2 style="margin: auto;">
              {{ product.title }}
            </h2>
          </v-card-title>

          <v-card-text>
            {{ product.description }}
          </v-card-text>

          <v-card-actions>
            <v-btn block class="primary" v-on:click="generate_token">
              Go To
              {{ product.title }}
            </v-btn>
          </v-card-actions>

          <v-alert
            :value="show_alert"
            :type="alert_type"
            transition="scale-transition"
            >{{ alert_text }}</v-alert
          >

          <v-progress-linear
            v-if="show_loading"
            :indeterminate="true"
          ></v-progress-linear>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* global firebase */
export default {
  name: "Authenticate_Product",
  data() {
    return {
      show_alert: false,
      show_loading: false,
      alert_type: "success",
      alert_text: "",
      product: {}
    };
  },
  created() {
    const auth_requester = this.$route.query.auth_requester;
    if (!auth_requester) {
      this.$router.push("/");
      return;
    }
    if (!this.$store.getters["user/is_logged_in"]) {
      this.$router.push({
        name: "Sign In",
        query: { auth_requester: auth_requester }
      });
      return;
    }
    if (!this.$store.getters["user/has_verified_mail"]) {
      this.$router.push({
        name: "Verify Mail",
        query: { auth_requester: auth_requester }
      });
      return;
    }
    this.show_loading = true;
    firebase
      .firestore()
      .collection("users")
      .doc(this.$store.getters["user/auth_profile"].uid)
      .collection("enabled_products")
      .doc(auth_requester)
      .get()
      .then(documentSnapshot => {
        if (!documentSnapshot.exists) {
          this.$router.push("/");
        } else {
          this.product = documentSnapshot.data();
          this.show_loading = false;
        }
      });
  },
  methods: {
    generate_token() {
      this.show_alert = false;
      this.show_loading = true;
      this.$store
        .dispatch("user/generate_sso_url", this.product.id)
        .then(result => {
          this.show_loading = false;
          window.location.href = result;
        })
        .catch(() => {
          this.show_loading = false;
          this.alert_type = "error";
          this.alert_text = "Could not Authenticate";
          this.show_alert = true;
        });
    }
  }
};
</script>

<style scoped>
#content_card {
  padding: 16px;
}
</style>
